// Core packages
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { User } from 'src/app/shared/models/user/user.model';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Component({
  selector: 'app-upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss']
})
export class UploadFileDialogComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser = new User();
  lang = this.translateService.currentLang || this.translateService.defaultLang;

  // BEGIN - Add subUser form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  showBcc = false;
  // END - ngx-formly

  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant('common.cta.upload'),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: 'primary',
    spinnerColor: 'primary',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    buttonIcon: {
      fontSet: 'fal',
      fontIcon: 'fa-file-upload',
      inline: true,
    },
  };
  // END - Add communication form

  dialogIsLoading = true;
  previousValue: any = {};

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<UploadFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public confirmDialog: MatDialog,
    public configService: ConfigService,

    private cookieService: CookieService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private suppliersService: SuppliersService,
    private authService: AuthService,
    private helperService: HelperService,
  ) { }

  /**
   * Init component
   *
   */
  ngOnInit(): void {
    // Get logged user data
    this.subscriptions.push(this.authService.loggedUser$.subscribe(res => this.loggedUser.setData(res)));

    // Get current lang
    this.lang = this.cookieService.get('lang') || this.configService.defaultLang;

    this.initForm();

    // Stop loading dialog
    setTimeout(() => {
      this.dialogIsLoading = false;
    }, 500);
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
  initForm(): void {
    // Set fields
    this.fields = [
      ...this.fields,
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: "col-12",
            type: "file-uploader",
            key: this.data.key,
            templateOptions: {
              required: false,
              // customLabel: this.translateService.instant('suppliers.fields.vc'),
              allowedFilesNumber: 1,
              allowedFilesExtensions: this.configService.allowedDocumentExtensions,
              bindLabel: "originalName",
            }
          },
        ],
      },
    ];
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(data?: any): void {
    this.dialogRef.close(data);
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(): void {
    this.dialogIsLoading = true;
    const newData = this.model;
    this.subscriptions.push(this.suppliersService.updateFields(this.data.supplierId, newData)
      .subscribe(
        res => {
          if (res.status) {
            const updatedData = res.supplier[this.data.key];

            this.dialogIsLoading = false;
            this.dialogRef.close(updatedData);
          }
        },
        err => {
          this.helperService.handleError(err);
        }
      ));

  }

}
